import {
  getTeamVacationsRequestsByYear,
  getTeamMemberVacationRequests,
  getYearHolidays,
  getHolidaysOnDateRange,
} from "../services/vacation.service"
import { DateTime } from "luxon"
import {
  EVENT_TYPES,
  HOLIDAY_SCHEMAS,
} from "../consts/modules/vacations.consts"
import {
  getVacationRequestPriority,
  getVacationState,
} from "../utils/vacation.utils"

const useFetchAdminVacationEvents = ({ selectedPeriod = /** @type {[DateTime, DateTime]} */ ([]) }) => {
  const fetchVacationRequests = async () => {
    const response = await getTeamVacationsRequestsByYear(
      selectedPeriod[0].year
    )
    if (!response.success) {
      throw new Error(response.message)
    }
    const events = formatVacationRequests(response.result)
    return events.sort((a, b) => a.priority - b.priority)
  }

  const fetchHolidays = async () => {
    const response = await getHolidaysOnDateRange(
      DateTime.fromISO(selectedPeriod[0].year).startOf("year"),
      DateTime.fromISO(selectedPeriod[0].year).endOf("year")
    )
    if (!response.success) {
      throw new Error(response.message)
    }
    const holidayEvents = formatHolidayEvents(response.result)
    return holidayEvents
  }

  return {
    fetchVacationRequests,
    fetchHolidays,
  }
}

const formatVacationRequests = (vacationRequests) => {
  const events = vacationRequests.map((request) => ({
    ...request,
    start: DateTime.fromISO(request.startDate?.split("T")[0])
      .startOf("day")
      .toJSDate(),
    end: DateTime.fromISO(request.endDate?.split("T")[0])
      .endOf("day")
      .toJSDate(),
    title: `${request.teamMember.name} ${request.teamMember.lastName}`,
    eventType: EVENT_TYPES.VACATION,
    holidaySchema:
      request.teamMember.idHolidaySchema === 1 ?
        HOLIDAY_SCHEMAS.MEXICAN
      : HOLIDAY_SCHEMAS.FOREIGN,
    status: getVacationState(request, false),
    priority: getVacationRequestPriority(request),
  }))
  return events
}

const formatHolidayEvents = (holidays) => {
  const flattenedHolidays = Object.values(holidays).flat()
  const holidayEvents = flattenedHolidays.map((holiday) => {
    let holidaySchema = HOLIDAY_SCHEMAS.MEXICAN
    let eventType = EVENT_TYPES.HOLIDAY
    if (holiday.holidayTypeId === 4) {
      eventType = EVENT_TYPES.GLOBAL_SISU
      holidaySchema = HOLIDAY_SCHEMAS.GLOBAL_SISU
    }
    return {
      ...holiday,
      start: DateTime.fromISO(holiday.date).startOf("day").toJSDate(),
      end: DateTime.fromISO(holiday.date).endOf("day").toJSDate(),
      title: holiday.name,
      eventType,
      holidaySchema,
    }
  })
  return holidayEvents
}

export default useFetchAdminVacationEvents
